import { render } from "./edit-enrolment.vue?vue&type=template&id=0a109eb6&ts=true"
import script from "./edit-enrolment.ts?vue&type=script&lang=ts&external"
export * from "./edit-enrolment.ts?vue&type=script&lang=ts&external"

import "./edit-enrolment.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__